<div class="loading-message" [ngClass]="'loading-' + type">
  <span class="message-text">{{ message }}</span>
  <span class="dots" *ngIf="type !== 'minimal'">
    <span class="dot">.</span>
    <span class="dot">.</span>
    <span class="dot">.</span>
  </span>
</div>
